<div class="item-column">
  <div class="column-header">
    <div class="header-left">
      <span class="header-title">Issues</span>
      <div class="issue-count" (click)="this.showComments.emit()">
        <img src="assets/img/chat.svg" class="icon" alt="" />
        <span class="header-count">({{ comments }})</span>
      </div>
    </div>

    <!-- <div class="header-right">
      <img src="assets/img/edit.svg" class="icon" alt="" />
      <span class="header-manage">Manage Issues</span>
    </div> -->
  </div>

  <div class="flag-groups" [ngClass]="{ 'has-checked-checkbox': anyCheckboxChecked() }">
    <hr />
    <div class="rec-groups" cdkScrollable>
      <div class="included">
        <h2>Included on Rec Letter ({{ includedGroups.length }})</h2>
        <div #includedList class="group-list">
          <ng-container *ngFor="let group of includedGroups; let index = index">
            <div
              class="flag"
              [attr.data-group-id]="group?.id"
              [ngClass]="{
                red: group?.subtype?.name === 'violation_level_1',
                orange: group?.subtype?.name === 'violation_level_2' || group?.subtype?.name === 'violation_level_3',
                grey: group?.subtype?.name === 'discrepancy',
                selected: selectedGroup == group,
                'group-background': isChecked(group)
              }"
              (click)="openGroup(group, index + 1)">
              <div class="drop-target" #dropTarget [attr.data-group-id]="group?.id"></div>
              <div class="group-detail">
                <div class="left">
                  <img [src]="getGroupIcon(group)" class="icon group-icon" alt="" />
                  <div class="cta cta-hover" [ngClass]="{ 'display-group': anyCheckboxChecked() }">
                    <img src="assets/img/svg/drag-handle-grey.svg" class="icon" alt="" />
                    <input
                      type="checkbox"
                      class="flag-checkbox"
                      [formControl]="group?.checkbox"
                      (click)="$event.stopPropagation()" />
                  </div>
                  <div class="text">
                    <span class="title">{{ group.name }}</span>
                    <span class="subtitle">{{ group.flags.length }} <span class="bold">flags</span></span>
                  </div>
                </div>
                <img
                  *ngIf="typeMap[group?.subtype?.type.id]"
                  [src]="'assets/img/' + typeMap[group.subtype.type.id]"
                  class="flag-icon"
                  alt="" />
              </div>

              <div
                class="cta-bottom-right cta-button"
                (click)="openConfirmationModal(group, index + 1); $event.stopPropagation()">
                <img src="assets/img/svg/trash-black.svg" class="delete" alt="" />
                <div class="tooltip">Delete</div>
              </div>
            </div>
          </ng-container>
        </div>
        <span style="font-family: Lato" *ngIf="includedGroups.length === 0">0 issues/groups</span>
      </div>
      <div class="notIncluded">
        <h2>Not on Rec Letter ({{ 1 + excludedGroups.length }})</h2>
        <div
          class="flag blue"
          (click)="openGroup(null)"
          [ngClass]="{
            selected: selectedGroup == null
          }"
          style="margin-bottom: 0px">
          <div class="drop-target" #dropTarget [attr.data-group-id]="null"></div>
          <div class="left">
            <img src="assets/img/blue-warning.svg" class="icon" alt="" />
            <div class="text">
              <span class="title">Uncategorized</span>
              <span class="subtitle">{{ countUncategorized }} <span class="bold">flags</span></span>
            </div>
          </div>
        </div>
        <div #excludedList class="group-list">
          <ng-container *ngFor="let group of excludedGroups; let index = index">
            <div
              class="flag"
              [attr.data-group-id]="group?.id"
              [ngClass]="{
                selected: selectedGroup === group,
                'group-background': isChecked(group)
              }"
              (click)="openGroup(group)">
              <div class="drop-target" #dropTarget [attr.data-group-id]="group?.id"></div>
              <div class="group-detail">
                <div class="left">
                  <img [src]="getGroupIcon(group)" class="icon group-icon" alt="" />
                  <div class="cta cta-hover" [ngClass]="{ 'display-group': anyCheckboxChecked() }">
                    <img src="assets/img/svg/drag-handle-grey.svg" class="icon" alt="" />
                    <input
                      type="checkbox"
                      class="flag-checkbox"
                      [formControl]="group?.checkbox"
                      (click)="$event.stopPropagation()" />
                  </div>
                  <div class="text">
                    <span class="title">{{ group.name }}</span>
                    <span class="subtitle">{{ group.flags.length }} <span class="bold">flags</span></span>
                  </div>
                </div>
                <img
                  *ngIf="typeMap[group?.subtype?.type.id]"
                  [src]="'assets/img/' + typeMap[group?.subtype?.type.id]"
                  class="flag-icon"
                  alt="" />
              </div>

              <div
                class="cta-bottom-right cta-button"
                (click)="openConfirmationModal(group, index + 1); $event.stopPropagation()">
                <img src="assets/img/svg/trash-black.svg" class="delete" alt="" />
                <div class="tooltip">Delete</div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <div class="add-group">
    <button class="add-group-btn" (click)="onAddGroup()">
      <svg class="dashed-border" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.3" y="0.3" fill="none" stroke="#6d7275" stroke-width="0.6" stroke-dasharray="6,6" rx="8" />
      </svg>
      <img src="assets/img/plus-icon.svg" class="flag-icon" alt="" />
      <span>Add Issue</span>
    </button>
  </div>
</div>
